import _ from 'lodash'
import PropTypes from 'prop-types'
import { useContext, useEffect } from 'react'

import { DiscardDialogContext } from '../../../../lib/global-discard-dialog'
import { SaveButton } from '../../../shared/FormBuilder'
import { Modal } from '../../../shared/NarusMaterial'

import AuditLog from './AuditLog'
import Form from './Form'

export default function ShareModal ({
  onClose,
  communicationMedium,
  reportMeta
}) {
  let formKey = `${communicationMedium}ReportShare`
  let discardDialog = useContext(DiscardDialogContext)
  let resetForm = discardDialog.resetForm

  useEffect(() => {
    return () => {
      resetForm(formKey)
    }
  }, [ resetForm, formKey ])

  const actions = [
    <SaveButton
      key={1}
      ignoreGlobalDisable
      label='Close'
      onClick={onClose}
    />
  ]

  return (
    <Modal
      title={`${_.capitalize(communicationMedium)} Document`}
      actions={actions}
      open
    >
      <Form
        formKey={`${communicationMedium}ReportShare`}
        communicationMedium={communicationMedium}
        reportMeta={reportMeta}
      />
      <h3>Audit Log</h3>
      <AuditLog
        patientId={reportMeta.patientId}
        reportId={reportMeta.reportId}
      />
    </Modal>
  )
}

ShareModal.propTypes = {
  reportMeta: PropTypes.shape({
    patientId: PropTypes.string,
    reportType: PropTypes.string,
    reportId: PropTypes.string
  }),
  communicationMedium: PropTypes.oneOf([ 'email', 'fax' ]).isRequired,
  onClose: PropTypes.func.isRequired
}
